/*
 * @Descripttion: 工业价格配置树数据转换
 * @Date: 2026-07-02 10:00:00
 */
import type {
  IndustryPriceNodeDTO,
  IndustryPriceTreeResponse,
  ScenePriceSceneItem
} from '../data-source/types';
import { fen2yuan } from '@/utils/translator';

/** 节点 industryId 不为空表示该场景已开通 */
const isSceneSelected = (node: IndustryPriceNodeDTO) => node.industryId != null;

/**
 * 接口节点转页面场景项
 */
const mapNodeToScene = (node: IndustryPriceNodeDTO): ScenePriceSceneItem => ({
  id: String(node.id),
  scenePath: node.serviceName,
  platformPriceLower: fen2yuan(node.platformLower, true),
  platformPriceUpper: fen2yuan(node.platformUpper, true),
  industryPriceLower:
    node.industryLower != null ? fen2yuan(node.industryLower, true) : null,
  industryPriceUpper:
    node.industryUpper != null ? fen2yuan(node.industryUpper, true) : null,
  enabled: isSceneSelected(node)
});

/**
 * 将工业价格配置接口 data 数组转为页面可用场景列表（仅三级场景）
 */
export const mapIndustryPriceTreeToScenes = (
  nodes: IndustryPriceNodeDTO[]
): ScenePriceSceneItem[] => {
  if (!nodes?.length) {
    return [];
  }

  return nodes
    .filter(item => item.platformLower != null && item.platformUpper != null)
    .map(mapNodeToScene);
};

/**
 * 解析 industryPriceTree 接口回参，取出 data 数组
 */
export const normalizeIndustryPriceTreeData = (
  payload: unknown
): IndustryPriceNodeDTO[] => {
  if (Array.isArray(payload)) {
    return payload as IndustryPriceNodeDTO[];
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  const response = payload as IndustryPriceTreeResponse;
  if (Array.isArray(response.data)) {
    return response.data;
  }

  return [];
};
